import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, ArrowUpRight, Lock } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function OpportunityCard({ opp, index = 0 }) {
  const navigate = useNavigate();
  const img = opp.images?.[0] ? fileUrl(opp.images[0]) : null;

  return (
    <div
      data-testid={`opportunity-card-${opp.deal_id}`}
      onClick={() => navigate(`/opportunities/${opp.slug}`)}
      className="group relative cursor-pointer overflow-hidden border border-gold/15 bg-obsidian transition-all duration-500 hover:-translate-y-1 hover:border-gold/40"
    >
      <div className="relative h-56 overflow-hidden">
        {img ? (
          <img src={img} alt={opp.title} className="h-full w-full object-cover opacity-70 transition-all duration-700 group-hover:scale-105 group-hover:opacity-90" />
        ) : (
          <div className="h-full w-full bg-seablue/40" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/40 to-transparent" />
        <div className="absolute left-4 top-4 flex items-center gap-1.5 border border-gold/40 bg-obsidian/80 px-3 py-1 backdrop-blur-sm">
          <Lock size={11} className="text-gold" />
          <span className="font-sans text-[10px] tracking-luxe uppercase text-champagne">{opp.badge}</span>
        </div>
        <span className="absolute bottom-4 right-4 font-mono text-[11px] text-gold">ID: {opp.deal_id}</span>
      </div>

      <div className="p-6">
        <div className="font-sans text-[10px] tracking-luxe uppercase text-gold">{opp.category}</div>
        <h3 className="mt-3 line-clamp-2 font-serif text-xl leading-snug text-warmwhite">{opp.title}</h3>

        <div className="mt-4 flex items-center gap-2 text-softgrey">
          <MapPin size={13} className="text-gold" />
          <span className="font-sans text-xs">{opp.location}</span>
        </div>

        <div className="mt-5 grid grid-cols-2 gap-4 border-t border-gold/10 pt-5">
          {opp.starting_price && (
            <div>
              <div className="font-sans text-[9px] tracking-luxe uppercase text-softgrey/60">From</div>
              <div className="mt-1 font-mono text-sm text-warmwhite">{opp.starting_price}</div>
            </div>
          )}
          {opp.founders_fee && (
            <div>
              <div className="font-sans text-[9px] tracking-luxe uppercase text-softgrey/60">Sourcing Fee</div>
              <div className="mt-1 font-mono text-sm text-champagne">{opp.founders_fee}</div>
            </div>
          )}
        </div>

        {opp.value_proposition && (
          <p className="mt-4 line-clamp-2 font-sans text-sm leading-relaxed text-softgrey">{opp.value_proposition}</p>
        )}

        <div className="mt-6 flex items-center gap-2 font-sans text-[12px] tracking-wide text-gold transition-all group-hover:gap-3">
          View Opportunity <ArrowUpRight size={15} />
        </div>
      </div>
    </div>
  );
}
